module.exports = __webpack_public_path__ + "static/media/blog1_web.f0cd2304.jpg";